export const capitalizeFirstLetter = (str: string = ''): string => {
  return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1)
}

export const pluralizeText = (str: string, count: number): string =>
  Math.floor(count) === 1 ? str : str + 's'

export const convertListToCommaSeparatedString = (dataList: string[]) => {
  return dataList.join(',')
}

export const joinListWithAnd = (stringList: string[]): string => {
  if (stringList.length === 1) {
    return stringList[0]
  }

  const lastString = stringList.pop()
  return `${stringList.join(', ')} and ${lastString}`
}

export const generateUniqueFieldName = (prefix: string): string => {
  return `${prefix}-${Math.floor(Math?.random() * 1000)}`
}

/**
 * Converts a string to title case while preserving uppercase acronyms
 * @param name - The string to convert to title case
 * @returns String in title case format
 */
export const toTitleCase = (name: string): string => {
  if (!name) return ''

  // Keep uppercase acronyms/codes (5 chars or less) as-is
  if (name === name.toUpperCase() && name.length <= 5) {
    return name
  }

  // Apply title case formatting
  return name
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}
